import { render, staticRenderFns } from "./ModelStorageBase.vue?vue&type=template&id=706657f3&"
import script from "./ModelStorageBase.vue?vue&type=script&lang=js&"
export * from "./ModelStorageBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports